<nav>
    <div class="navbar-logo-container me-auto">
        <a class="navbar-logo-link" [routerLink]="'/' + translate.getActiveLang()">
            <img id="navbar-logo" src="/assets/images/radish-logos/Radish-Logo-BlackText-Large.png" alt="Radish" />
        </a>
    </div>
    <div class="navbar-controls">
        <div class="dropdown-wrapper">
            <button (click)="toggleDeliverySolutions()">
                {{ 'landing.navbar.solutions.label' | transloco }}

                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" class="down-angle"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.--><path d="M297.4 438.6C309.9 451.1 330.2 451.1 342.7 438.6L502.7 278.6C515.2 266.1 515.2 245.8 502.7 233.3C490.2 220.8 469.9 220.8 457.4 233.3L320 370.7L182.6 233.4C170.1 220.9 149.8 220.9 137.3 233.4C124.8 245.9 124.8 266.2 137.3 278.7L297.3 438.7z"/></svg>
            </button>
            @if (deliverySolutionsOpen) {
            <div class="dropdown" (clickOutside)="deliverySolutionsOpen=false" [delayClickOutsideInit]="true">
                <a href="{{ 'landing.navbar.solutions.lastMile.href' | transloco }}" target="_blank"
                    rel="noopener noreferrer">
                    {{ 'landing.navbar.solutions.lastMile.label' | transloco }}
                </a>
                <a [routerLink]="'/' + translate.getActiveLang() + '/horseradish'">
                    {{ 'landing.navbar.solutions.horseradish.label' | transloco }}
                </a>
            </div>
            }
        </div>

        <a href="{{ 'landing.navbar.careers.href' | transloco }}" target="_blank" rel="noopener noreferrer">
            {{ 'landing.navbar.careers.label' | transloco }}
        </a>
        <a [routerLink]="'/blog'">
            {{ 'landing.navbar.stories.label' | transloco }}
        </a>
        @if (page=='landing') {
        <button class="rad-btn-cta" [routerLink]="'/' + translate.getActiveLang() + '/restaurants'">
            <span>{{ 'landing.navbar.cta.orderFood' | transloco }}</span>
        </button>
        } @else {
        <a href="mailto:horse@radish.coop" target="_blank" class="rad-btn-cta">
            <span>{{ 'horseradish.hero.cta' | transloco }}</span>
        </a>
        }
    </div>
    <div class="profile-controls">
        <div class="profile-container">
        @if(user$ | async; as user) {
            <img class="navbar-user-dropdown-icon navbar-icon" src="/assets/images/icons/user.svg" />
            <span>{{ user.name.first }}</span>
        }
        @else {
            @if((isProcessing$ | async) !== false) {
                <div class="loading-container loading-gradient"></div>
            }
            @else {
                <a [routerLink]="'/' + translate.getActiveLang() + '/login'">
                    <span>{{ 'navbar.signup' | transloco }}</span>
                </a>
            }
        }
        </div>
        <button class="language-selector" (click)="setLanguage(this.translate.getActiveLang() == 'en' ? 'fr' : 'en')">
            {{ 'common.languages.' + (this.translate.getActiveLang() == 'en' ? 'fr' : 'en') | transloco }}
        </button>
    </div>
    <!-- Mobile and tablets -->
    <div class="mobile-menu-container">
        <svg class="bars-icon" xmlns="http://www.w3.org/2000/svg" (click)="toggleMenu()"
            viewBox="0 0 640 640"><!--!Font Awesome Free v7.0.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
            <path
                d="M96 160C96 142.3 110.3 128 128 128L512 128C529.7 128 544 142.3 544 160C544 177.7 529.7 192 512 192L128 192C110.3 192 96 177.7 96 160zM96 320C96 302.3 110.3 288 128 288L512 288C529.7 288 544 302.3 544 320C544 337.7 529.7 352 512 352L128 352C110.3 352 96 337.7 96 320zM544 480C544 497.7 529.7 512 512 512L128 512C110.3 512 96 497.7 96 480C96 462.3 110.3 448 128 448L512 448C529.7 448 544 462.3 544 480z" />
        </svg>
        <div class="mobile-menu" [class.open]="menuOpen">
            <div class="dropdown-wrapper" [class.open]="deliverySolutionsOpen">
                <button (click)="toggleDeliverySolutions()">
                    {{ 'landing.navbar.solutions.label' | transloco }}

                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" class="down-angle"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.--><path d="M297.4 438.6C309.9 451.1 330.2 451.1 342.7 438.6L502.7 278.6C515.2 266.1 515.2 245.8 502.7 233.3C490.2 220.8 469.9 220.8 457.4 233.3L320 370.7L182.6 233.4C170.1 220.9 149.8 220.9 137.3 233.4C124.8 245.9 124.8 266.2 137.3 278.7L297.3 438.7z"/></svg>
                </button>
                <div class="dropdown">
                    <div>
                        <a href="{{ 'landing.navbar.solutions.lastMile.href' | transloco }}" target="_blank"
                            rel="noopener noreferrer">
                            {{ 'landing.navbar.solutions.lastMile.label' | transloco }}
                        </a>
                        <a [routerLink]="'/' + translate.getActiveLang() + '/horseradish'">
                            {{ 'landing.navbar.solutions.horseradish.label' | transloco }}
                        </a>
                    </div>
                </div>
            </div>
            <a href="{{ 'landing.navbar.careers.href' | transloco }}" target="_blank" rel="noopener noreferrer">
                {{ 'landing.navbar.careers.label' | transloco }}
            </a>
            <a [routerLink]="'/blog'">
                {{ 'landing.navbar.stories.label' | transloco }}
            </a>
            <button class="language-selector mobile"
                (click)="setLanguage(this.translate.getActiveLang() == 'en' ? 'fr' : 'en')">
                {{ 'common.languages.' + (this.translate.getActiveLang() == 'en' ? 'fr' : 'en') | transloco }}
            </button>
            <button class="rad-btn-cta" [routerLink]="'/' + translate.getActiveLang() + '/restaurants'">
                <span>{{ (page=='landing' ? 'landing.navbar.cta.orderFood' : 'horseradish.hero.cta') | transloco }}</span>
            </button>
        </div>
    </div>
</nav>
